<template>
  <div class="qr-scanner-container">
    <div v-if="!cameraActive" class="scanner-placeholder">
      <button @click="startScanner" class="scan-btn">
        <img src="@/assets/images/camera.svg" alt="Scan" v-if="hasCameraIcon">
        <span>QR-Code scannen</span>
      </button>
    </div>
    
    <teleport to="body">
      <div v-show="cameraActive" class="scanner-active">
        <div id="qr-reader" class="qr-reader"></div>
        <button @click="stopScanner" class="cancel-btn">Abbrechen</button>
      </div>
    </teleport>
  </div>
</template>

<script>
import { Html5Qrcode } from "html5-qrcode";

export default {
  name: "QRScanner",
  data() {
    return {
      cameraActive: false,
      html5QrCode: null,
      hasCameraIcon: true // Check if icon exists or fallback
    };
  },
  methods: {
    async startScanner() {
      this.cameraActive = true;
      this.$nextTick(async () => {
        try {
          this.html5QrCode = new Html5Qrcode("qr-reader");
          const config = { fps: 10, qrbox: { width: 250, height: 250 } };
          
          await this.html5QrCode.start(
            { facingMode: "environment" },
            config,
            (decodedText) => {
              // Extract code from URL if it's a full link, or use as is
              let code = decodedText;
              if (decodedText.includes('/join/')) {
                code = decodedText.split('/join/')[1].split(/[?#]/)[0];
              } else if (decodedText.includes('?join=')) {
                code = decodedText.split('?join=')[1].split(/[?#]/)[0];
              }
              
              this.$emit('scan', code.toUpperCase());
              this.stopScanner();
            },
            () => {
              // QR Code not found in frame, ignore
            }
          );
        } catch (err) {
          console.error("Scanner failed to start:", err);
          alert("Kamera konnte nicht gestartet werden. Bitte Berechtigung prüfen.");
          this.cameraActive = false;
        }
      });
    },
    async stopScanner() {
      if (this.html5QrCode && this.html5QrCode.isScanning) {
        await this.html5QrCode.stop();
        this.html5QrCode.clear();
      }
      this.cameraActive = false;
    }
  },
  beforeUnmount() {
    this.stopScanner();
  }
};
</script>

<style scoped>
.qr-scanner-container {
  width: 100%;
  margin: 10px 0;
}

.scanner-placeholder {
  display: flex;
  justify-content: center;
}

.scan-btn {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--background-secondary);
  color: var(--primary-color);
  border: 1px solid var(--border-color);
  padding: 12px 20px;
  border-radius: var(--radius-m);
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  justify-content: center;
}

.scan-btn img {
  width: 20px;
  height: 20px;
  filter: var(--icon-filter);
}

.scanner-active {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  bottom: 90px; /* Respect the footer */
  background: black;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.qr-reader {
  width: 100%;
  max-width: 500px;
  border-radius: var(--radius-l);
  overflow: hidden;
}

.cancel-btn {
  margin-top: 30px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.3);
  padding: 12px 30px;
  border-radius: var(--radius-m);
  font-weight: 600;
  backdrop-filter: blur(10px);
}
</style>
